import React, { useCallback, useState, useEffect } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import firebase from "./constants/firebase";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import IconButton from '@material-ui/core/IconButton';
import HomeIcon from '@material-ui/icons/Home';
import theme from './Themer';
import {ThemeProvider} from '@material-ui/core/styles';
import Copyright from './Copyright'
import Paper from "@material-ui/core/Paper";


const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: props => ({
    margin: theme.spacing(1),
    backgroundColor: props.palette.primary.dark,
  }),
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: props => ({
    margin: theme.spacing(3, 0, 2),
    backgroundColor: props.palette.primary.main
  }),
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  title: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  loginButton: props => ({
    background: props.palette.gradient.default,
    color: 'black',
  }),
  paperBig: {
    width: "100%",
    minHeight: "100vh",
    color: "inherit",
  },
}));

export default function Login(props) {
  const { history } = props;
  const currentTheme = theme();
  const classes = useStyles(currentTheme);


  const handleLogin = useCallback(
    async event => {
      event.preventDefault();
      const { email, password } = event.target.elements;
      try {
        await firebase
          .auth()
          .signInWithEmailAndPassword(email.value, password.value);
        history.push("/dashboard");
      } catch (error) {
        alert(error);
      }
    },
    [history]
  );

  const handleHome = () => {
    history.push("/")
  };

  const handleSignUp= () => {
    history.push("/register")
};

  useEffect(() => {
    // TODO: Hacky but needed
    if (firebase.auth().currentUser) {
      history.push("/dashboard");
    }
  });

  return (
    <ThemeProvider theme={currentTheme}>
    <Container component="main" maxWidth="xs" minHeight="100vh">
      <CssBaseline />
      <AppBar
        position="fixed"
      >
        <Toolbar>
          <IconButton
              color="inherit"
              edge="end"
              onClick={handleHome}
              className={classes.menuButton}
            >
              <HomeIcon />
          </IconButton>
          <Typography variant="h6" noWrap className={classes.title}>
               BIB XVI Registration Portal
          </Typography>
          <ButtonGroup variant="contained" color="primary" aria-label="contained primary button group">
            <Button classes={{root: classes.loginButton}} onClick={handleSignUp}>Sign Up</Button>
        </ButtonGroup>
        </Toolbar>
      </AppBar>
      <Box p={5}/>
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon/>
        </Avatar>
        <Typography component="h1" variant="h5">
          Login
        </Typography>
        <form className={classes.form} onSubmit={handleLogin}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Login
          </Button>
          <Grid container>
            <Grid item xs>
              <Link href="#/forgot" variant="body2">
                Forgot password?
              </Link>
            </Grid>
            <Grid item>
              <Link href="#/register" variant="body2">
                {"Don't have an account? Sign Up"}
              </Link>
            </Grid>
          </Grid>
        </form>
      </div>
      <Box mt={8} minHeight="100vh">
        <Copyright />
      </Box>
    </Container>
    </ThemeProvider>
  );
}